export type EstadoCancion = 'pendiente' | 'aceptada' | 'rechazada' | 'al_aire';

export interface CancionSolicitada {
  id: number;
  cancion: string;
  artista: string;
  portada: string;
  solicitante: string;
  solicitanteAvatar: string;
  solicitanteCiudad: string;
  mensaje: string;
  dedicatoria: string;
  estado: EstadoCancion;
  fechaSolicitud: string;
  fechaAceptacion?: string;
  fechaAlAire?: string;
  fechaRechazo?: string;
  motivoRechazo?: string;
  compartidos: number;
  participantes: number;
  score: number;
}

export interface TopCancion {
  cancion: string;
  artista: string;
  portada: string;
  solicitudes: number;
  vecesAlAire: number;
  posicion: number;
}

export interface ScoreAccion {
  id: string;
  accion: string;
  icono: string;
  color: string;
  puntos: number;
  descripcion: string;
}

export interface ReglaCanciones {
  id: number;
  titulo: string;
  descripcion: string;
  icono: string;
  color: string;
}

export const coverImage = 'https://readdy.ai/api/search-image?query=Modern%20radio%20broadcast%20studio%20interior%20with%20professional%20microphone%20on%20desk%20warm%20ambient%20golden%20lighting%20sound%20mixer%20equipment%20acoustic%20panels%20on%20walls%20elegant%20warm%20atmosphere%20music%20recording%20booth%20with%20soft%20bokeh%20background%20cinematic%20composition%20depth%20of%20field%20clean%20refined%20aesthetic&width=1800&height=800&seq=canciones-solicitadas-hero&orientation=landscape';

export const topCanciones: TopCancion[] = [
  { cancion: 'Vivir Mi Vida', artista: 'Marc Anthony', portada: 'https://readdy.ai/api/search-image?query=Warm%20golden%20music%20album%20cover%20aesthetic%20vibrant%20tropical%20colors%20dance%20celebration%20mood%20with%20abstract%20palm%20leaves%20and%20sun%20rays%20minimal%20text%20area%20glowing%20atmosphere&width=400&height=400&seq=top-song-vivir-mi-vida&orientation=squarish', solicitudes: 47, vecesAlAire: 28, posicion: 1 },
  { cancion: 'Bailando', artista: 'Enrique Iglesias', portada: 'https://readdy.ai/api/search-image?query=Warm%20red%20and%20gold%20music%20album%20cover%20aesthetic%20latin%20dance%20rhythm%20passion%20theme%20with%20elegant%20abstract%20swirls%20romantic%20sunset%20colors%20clean%20minimal%20style&width=400&height=400&seq=top-song-bailando&orientation=squarish', solicitudes: 38, vecesAlAire: 22, posicion: 2 },
  { cancion: 'Despacito', artista: 'Luis Fonsi ft. Daddy Yankee', portada: 'https://readdy.ai/api/search-image?query=Tropical%20turquoise%20and%20coral%20music%20album%20cover%20aesthetic%20summer%20beach%20vibe%20gentle%20waves%20pastel%20sunset%20sky%20clean%20modern%20minimal%20design%20elegant%20warm%20tones&width=400&height=400&seq=top-song-despacito&orientation=squarish', solicitudes: 35, vecesAlAire: 19, posicion: 3 },
  { cancion: 'A Puro Dolor', artista: 'Sin Bandera', portada: 'https://readdy.ai/api/search-image?query=Soft%20grey%20and%20dusty%20rose%20music%20album%20cover%20aesthetic%20melancholic%20romantic%20ballad%20mood%20subtle%20raindrops%20texture%20on%20glass%20elegant%20minimalist%20design%20gentle%20lighting&width=400&height=400&seq=top-song-a-puro-dolor&orientation=squarish', solicitudes: 31, vecesAlAire: 17, posicion: 4 },
  { cancion: 'La Bicicleta', artista: 'Carlos Vives & Shakira', portada: 'https://readdy.ai/api/search-image?query=Vibrant%20yellow%20and%20sky%20blue%20music%20album%20cover%20aesthetic%20joyful%20summer%20bicycle%20ride%20countryside%20theme%20warm%20sunlight%20golden%20fields%20clean%20modern%20style&width=400&height=400&seq=top-song-la-bicicleta&orientation=squarish', solicitudes: 28, vecesAlAire: 15, posicion: 5 },
  { cancion: 'Hawái', artista: 'Maluma', portada: 'https://readdy.ai/api/search-image?query=Warm%20sunset%20orange%20and%20teal%20music%20album%20cover%20aesthetic%20tropical%20island%20paradise%20palm%20tree%20silhouette%20ocean%20horizon%20elegant%20clean%20minimal%20composition%20dreamy%20atmosphere&width=400&height=400&seq=top-song-hawaii&orientation=squarish', solicitudes: 26, vecesAlAire: 14, posicion: 6 },
  { cancion: 'El Favor', artista: 'Paty Cantú', portada: 'https://readdy.ai/api/search-image?query=Soft%20lavender%20and%20warm%20peach%20music%20album%20cover%20aesthetic%20empowering%20female%20energy%20theme%20abstract%20light%20rays%20breaking%20through%20clouds%20elegant%20minimalist%20design%20gentle%20gradient&width=400&height=400&seq=top-song-el-favor&orientation=squarish', solicitudes: 24, vecesAlAire: 13, posicion: 7 },
  { cancion: 'Me Rehúso', artista: 'Danny Ocean', portada: 'https://readdy.ai/api/search-image?query=Deep%20navy%20and%20warm%20amber%20music%20album%20cover%20aesthetic%20emotional%20breakup%20anthem%20theme%20city%20lights%20at%20night%20distant%20skyline%20clean%20modern%20minimalist%20style%20elegant%20contrast&width=400&height=400&seq=top-song-me-rehuso&orientation=squarish', solicitudes: 23, vecesAlAire: 12, posicion: 8 },
  { cancion: 'Tusa', artista: 'Karol G & Nicki Minaj', portada: 'https://readdy.ai/api/search-image?query=Bold%20magenta%20and%20electric%20pink%20music%20album%20cover%20aesthetic%20powerful%20female%20empowerment%20anthem%20theme%20glossy%20metallic%20sheen%20clean%20elegant%20modern%20composition%20confident%20energy&width=400&height=400&seq=top-song-tusa&orientation=squarish', solicitudes: 21, vecesAlAire: 11, posicion: 9 },
  { cancion: 'Robarte un Beso', artista: 'Carlos Vives & Sebastián Yatra', portada: 'https://readdy.ai/api/search-image?query=Warm%20honey%20gold%20and%20soft%20coral%20music%20album%20cover%20aesthetic%20romantic%20countryside%20charm%20folk%20acoustic%20guitar%20strings%20closeup%20clean%20elegant%20minimal%20composition%20gentle%20natural%20light&width=400&height=400&seq=top-song-robarte-un-beso&orientation=squarish', solicitudes: 20, vecesAlAire: 10, posicion: 10 },
];

export const cancionesSolicitadas: CancionSolicitada[] = [
  {
    id: 1,
    cancion: 'Vivir Mi Vida',
    artista: 'Marc Anthony',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20golden%20tropical%20music%20album%20cover%20aesthetic%20celebration%20joy%20theme%20abstract%20sunny%20composition%20rich%20amber%20tones%20clean%20elegant%20minimal%20design&width=400&height=400&seq=req-vivir-mi-vida&orientation=squarish',
    solicitante: 'Carlos Ramírez',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%20friendly%20warm%20expression%20casual%20polo%20shirt%20natural%20daylight%20clean%20background%20soft%20lighting&width=80&height=80&seq=req-carlos-r&orientation=squarish',
    solicitanteCiudad: 'San José',
    mensaje: 'Para todos los que están pasando por un mal momento, ¡la vida es una sola y hay que vivirla!',
    dedicatoria: 'A mi familia que siempre me apoya en los momentos difíciles.',
    estado: 'al_aire',
    fechaSolicitud: '2026-06-21T14:25:00',
    fechaAceptacion: '2026-06-21T14:30:00',
    fechaAlAire: '2026-06-21T14:42:00',
    compartidos: 28,
    participantes: 15,
    score: 85,
  },
  {
    id: 2,
    cancion: 'Bailando',
    artista: 'Enrique Iglesias',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20red%20and%20gold%20music%20album%20cover%20aesthetic%20latin%20dance%20passion%20theme%20elegant%20abstract%20swirls%20romantic%20energy%20clean%20modern%20minimal%20design&width=400&height=400&seq=req-bailando&orientation=squarish',
    solicitante: 'Sofía Hernández',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20trendy%20casual%20style%20bright%20genuine%20smile%20soft%20studio%20light%20clean%20background&width=80&height=80&seq=req-sofia-h&orientation=squarish',
    solicitanteCiudad: 'San José',
    mensaje: 'Esta canción me recuerda los mejores momentos con mis amigos del cole.',
    dedicatoria: '',
    estado: 'al_aire',
    fechaSolicitud: '2026-06-21T14:10:00',
    fechaAceptacion: '2026-06-21T14:15:00',
    fechaAlAire: '2026-06-21T14:20:00',
    compartidos: 35,
    participantes: 22,
    score: 92,
  },
  {
    id: 3,
    cancion: 'Despacito',
    artista: 'Luis Fonsi ft. Daddy Yankee',
    portada: 'https://readdy.ai/api/search-image?query=Tropical%20turquoise%20and%20coral%20music%20album%20cover%20aesthetic%20summer%20beach%20paradise%20gentle%20waves%20golden%20sand%20clean%20elegant%20minimal%20design%20peaceful%20atmosphere&width=400&height=400&seq=req-despacito&orientation=squarish',
    solicitante: 'Pedro Gutiérrez',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20gentle%20eyes%20simple%20casual%20style%20natural%20warm%20lighting%20clean%20background&width=80&height=80&seq=req-pedro-g&orientation=squarish',
    solicitanteCiudad: 'Alajuela',
    mensaje: 'Dedicada a mi esposa Laura, 25 años juntos y contando. ¡Te amo!',
    dedicatoria: 'Para Laura, mi compañera de vida, gracias por estos 25 años maravillosos.',
    estado: 'aceptada',
    fechaSolicitud: '2026-06-21T14:05:00',
    fechaAceptacion: '2026-06-21T14:08:00',
    compartidos: 12,
    participantes: 8,
    score: 45,
  },
  {
    id: 4,
    cancion: 'A Puro Dolor',
    artista: 'Sin Bandera',
    portada: 'https://readdy.ai/api/search-image?query=Soft%20grey%20and%20dusty%20rose%20music%20album%20cover%20aesthetic%20melancholic%20romantic%20ballad%20mood%20elegant%20gradient%20tones%20subtle%20light%20rays%20clean%20minimalist%20design&width=400&height=400&seq=req-a-puro-dolor&orientation=squarish',
    solicitante: 'Roberto Sánchez',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%20casual%20friendly%20style%20natural%20daylight%20warm%20expression%20clean%20background&width=80&height=80&seq=req-roberto-s&orientation=squarish',
    solicitanteCiudad: 'Cartago',
    mensaje: 'Para todos los corazones rotos, ¡ánimo que siempre sale el sol!',
    dedicatoria: 'A quienes están sanando, todo pasa y todo mejora.',
    estado: 'pendiente',
    fechaSolicitud: '2026-06-21T14:02:00',
    compartidos: 3,
    participantes: 1,
    score: 10,
  },
  {
    id: 5,
    cancion: 'La Bicicleta',
    artista: 'Carlos Vives & Shakira',
    portada: 'https://readdy.ai/api/search-image?query=Vibrant%20yellow%20and%20sky%20blue%20music%20album%20cover%20aesthetic%20joyful%20countryside%20ride%20theme%20warm%20sunlight%20golden%20wheat%20fields%20clean%20modern%20minimal%20composition&width=400&height=400&seq=req-la-bicicleta&orientation=squarish',
    solicitante: 'Valentina Castro',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20creative%20style%20warm%20inviting%20smile%20soft%20ambient%20light%20clean%20background&width=80&height=80&seq=req-valentina-c&orientation=squarish',
    solicitanteCiudad: 'Heredia',
    mensaje: 'Para Diego y Natalia, que ponen la mejor música mientras pinto.',
    dedicatoria: 'A mis compañeros de estudio, gracias por la buena vibra siempre.',
    estado: 'pendiente',
    fechaSolicitud: '2026-06-21T13:55:00',
    compartidos: 5,
    participantes: 2,
    score: 15,
  },
  {
    id: 6,
    cancion: 'Hawái',
    artista: 'Maluma',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20sunset%20orange%20and%20teal%20music%20album%20cover%20aesthetic%20tropical%20paradise%20palm%20tree%20silhouette%20ocean%20horizon%20clean%20elegant%20minimal%20composition%20dreamy%20atmosphere&width=400&height=400&seq=req-hawaii&orientation=squarish',
    solicitante: 'Camila Soto',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20modern%20trendy%20style%20bright%20genuine%20smile%20natural%20daylight%20clean%20background&width=80&height=80&seq=req-camila-s&orientation=squarish',
    solicitanteCiudad: 'Cartago',
    mensaje: 'Para desconectar de la rutina y viajar con la imaginación.',
    dedicatoria: '',
    estado: 'rechazada',
    fechaSolicitud: '2026-06-21T13:45:00',
    fechaRechazo: '2026-06-21T13:50:00',
    motivoRechazo: 'Canción ya solicitada 3 veces hoy — límite diario alcanzado.',
    compartidos: 0,
    participantes: 0,
    score: 0,
  },
  {
    id: 7,
    cancion: 'Me Rehúso',
    artista: 'Danny Ocean',
    portada: 'https://readdy.ai/api/search-image?query=Deep%20navy%20and%20warm%20amber%20music%20album%20cover%20aesthetic%20emotional%20urban%20anthem%20theme%20distant%20city%20lights%20night%20atmosphere%20clean%20modern%20minimalist%20style&width=400&height=400&seq=req-me-rehuso&orientation=squarish',
    solicitante: 'Diego Vargas',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%20stylish%20casual%20look%20confident%20friendly%20expression%20modern%20studio%20lighting%20clean%20warm%20background&width=80&height=80&seq=req-diego-v&orientation=squarish',
    solicitanteCiudad: 'Alajuela',
    mensaje: 'Esta canción fue el soundtrack de mi último año de universidad.',
    dedicatoria: 'A mis compañeros de la U, los llevo en el corazón.',
    estado: 'al_aire',
    fechaSolicitud: '2026-06-21T13:20:00',
    fechaAceptacion: '2026-06-21T13:25:00',
    fechaAlAire: '2026-06-21T13:30:00',
    compartidos: 42,
    participantes: 30,
    score: 110,
  },
  {
    id: 8,
    cancion: 'El Favor',
    artista: 'Paty Cantú',
    portada: 'https://readdy.ai/api/search-image?query=Soft%20lavender%20and%20warm%20peach%20music%20album%20cover%20aesthetic%20empowering%20feminine%20energy%20theme%20elegant%20light%20rays%20composition%20clean%20minimalist%20design%20gentle%20atmosphere&width=400&height=400&seq=req-el-favor&orientation=squarish',
    solicitante: 'Natalia Campos',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20in%20her%2030s%20warm%20friendly%20smile%20casual%20chic%20style%20soft%20natural%20daylight%20clean%20background&width=80&height=80&seq=req-natalia-c&orientation=squarish',
    solicitanteCiudad: 'Alajuela',
    mensaje: 'Para mi mejor amiga que está pasando por una ruptura. ¡Arriba amiga, tú puedes!',
    dedicatoria: 'Para Mariana, que sepa que no está sola. ¡Fuerza!',
    estado: 'aceptada',
    fechaSolicitud: '2026-06-21T13:10:00',
    fechaAceptacion: '2026-06-21T13:12:00',
    compartidos: 18,
    participantes: 10,
    score: 52,
  },
  {
    id: 9,
    cancion: 'Tusa',
    artista: 'Karol G & Nicki Minaj',
    portada: 'https://readdy.ai/api/search-image?query=Bold%20magenta%20and%20electric%20pink%20music%20album%20cover%20aesthetic%20powerful%20female%20empowerment%20anthem%20glossy%20modern%20sheen%20clean%20elegant%20composition%20confident%20energy&width=400&height=400&seq=req-tusa&orientation=squarish',
    solicitante: 'Andrea Torres',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20bright%20smile%20everyday%20casual%20look%20soft%20daylight%20studio%20lighting%20friendly%20expression%20clean%20light%20background&width=80&height=80&seq=req-andrea-t&orientation=squarish',
    solicitanteCiudad: 'Cartago',
    mensaje: 'Después de una ruptura, esta canción es pura terapia.',
    dedicatoria: '',
    estado: 'rechazada',
    fechaSolicitud: '2026-06-21T12:55:00',
    fechaRechazo: '2026-06-21T13:00:00',
    motivoRechazo: 'Contenido no apto para el horario familiar actual.',
    compartidos: 0,
    participantes: 0,
    score: 0,
  },
  {
    id: 10,
    cancion: 'Robarte un Beso',
    artista: 'Carlos Vives & Sebastián Yatra',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20honey%20gold%20and%20soft%20coral%20music%20album%20cover%20aesthetic%20romantic%20countryside%20charm%20folk%20acoustic%20guitar%20closeup%20clean%20elegant%20minimal%20natural%20light&width=400&height=400&seq=req-robarte-un-beso&orientation=squarish',
    solicitante: 'Javier Núñez',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%20trendy%20street%20style%20charismatic%20smile%20urban%20studio%20lighting%20clean%20background&width=80&height=80&seq=req-javier-n&orientation=squarish',
    solicitanteCiudad: 'San José',
    mensaje: 'Se la dedico a mi crush, a ver si se da cuenta de una vez.',
    dedicatoria: 'Para María José, que cada día me roba el aliento.',
    estado: 'al_aire',
    fechaSolicitud: '2026-06-21T12:30:00',
    fechaAceptacion: '2026-06-21T12:35:00',
    fechaAlAire: '2026-06-21T12:42:00',
    compartidos: 55,
    participantes: 38,
    score: 130,
  },
  {
    id: 11,
    cancion: 'Vivir Mi Vida',
    artista: 'Marc Anthony',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20golden%20tropical%20happiness%20music%20album%20cover%20aesthetic%20pure%20celebration%20energy%20abstract%20radiant%20sunburst%20rich%20amber%20tones%20clean%20elegant%20design&width=400&height=400&seq=req-vivir-mi-vida-2&orientation=squarish',
    solicitante: 'Lucía Mendoza',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%20natural%20makeup%20casual%20look%20soft%20natural%20light%20clean%20bright%20background&width=80&height=80&seq=req-lucia-m&orientation=squarish',
    solicitanteCiudad: 'Heredia',
    mensaje: 'Para mi abuelita que ya salió del hospital. ¡Bienvenida a casa abue!',
    dedicatoria: 'Para la abuelita más fuerte del mundo. Te amamos.',
    estado: 'al_aire',
    fechaSolicitud: '2026-06-21T11:50:00',
    fechaAceptacion: '2026-06-21T11:55:00',
    fechaAlAire: '2026-06-21T12:05:00',
    compartidos: 68,
    participantes: 45,
    score: 155,
  },
  {
    id: 12,
    cancion: 'Bailando',
    artista: 'Enrique Iglesias',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20crimson%20and%20gold%20latin%20dance%20music%20album%20cover%20aesthetic%20passionate%20rhythm%20energy%20elegant%20flowing%20movement%20abstract%20composition%20clean%20modern%20design&width=400&height=400&seq=req-bailando-2&orientation=squarish',
    solicitante: 'Daniela Quirós',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%20sporty%20casual%20look%20energetic%20smile%20bright%20natural%20light%20clean%20background&width=80&height=80&seq=req-daniela-q&orientation=squarish',
    solicitanteCiudad: 'San José',
    mensaje: 'Para celebrar que aprobé todos los exámenes de este semestre.',
    dedicatoria: '',
    estado: 'al_aire',
    fechaSolicitud: '2026-06-21T11:20:00',
    fechaAceptacion: '2026-06-21T11:25:00',
    fechaAlAire: '2026-06-21T11:35:00',
    compartidos: 22,
    participantes: 14,
    score: 70,
  },
  {
    id: 13,
    cancion: 'Despacito',
    artista: 'Luis Fonsi ft. Daddy Yankee',
    portada: 'https://readdy.ai/api/search-image?query=Soft%20turquoise%20and%20warm%20coral%20tropical%20music%20album%20cover%20aesthetic%20gentle%20ocean%20breeze%20calm%20paradise%20evening%20light%20clean%20elegant%20minimalist%20design%20serene%20atmosphere&width=400&height=400&seq=req-despacito-2&orientation=squarish',
    solicitante: 'Eduardo Paredes',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%20casual%20professional%20style%20friendly%20but%20serious%20expression%20studio%20lighting%20clean%20background&width=80&height=80&seq=req-eduardo-p&orientation=squarish',
    solicitanteCiudad: 'San José',
    mensaje: 'Para cerrar la jornada laboral con buena vibra.',
    dedicatoria: 'Para todo el equipo de trabajo, ¡lo dimos todo hoy!',
    estado: 'pendiente',
    fechaSolicitud: '2026-06-21T10:45:00',
    compartidos: 1,
    participantes: 0,
    score: 5,
  },
  {
    id: 14,
    cancion: 'A Puro Dolor',
    artista: 'Sin Bandera',
    portada: 'https://readdy.ai/api/search-image?query=Soft%20silver%20and%20dusty%20mauve%20music%20album%20cover%20aesthetic%20gentle%20melancholy%20romantic%20ballad%20mood%20silky%20gradients%20clean%20elegant%20minimalist%20design&width=400&height=400&seq=req-a-puro-dolor-2&orientation=squarish',
    solicitante: 'Gabriela Mora',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20professional%20Latina%20woman%20business%20casual%20confident%20smile%20soft%20studio%20light%20clean%20background&width=80&height=80&seq=req-gabriela-m&orientation=squarish',
    solicitanteCiudad: 'Limón',
    mensaje: 'A veces hace falta una canción que te entienda sin decir nada.',
    dedicatoria: '',
    estado: 'rechazada',
    fechaSolicitud: '2026-06-21T10:15:00',
    fechaRechazo: '2026-06-21T10:20:00',
    motivoRechazo: 'Solicitud duplicada — el oyente ya tiene una canción pendiente en cola.',
    compartidos: 0,
    participantes: 0,
    score: 0,
  },
  {
    id: 15,
    cancion: 'La Bicicleta',
    artista: 'Carlos Vives & Shakira',
    portada: 'https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20yellow%20and%20soft%20sky%20blue%20music%20album%20cover%20aesthetic%20peaceful%20countryside%20path%20winding%20through%20fields%20clean%20elegant%20modern%20minimal%20design&width=400&height=400&seq=req-la-bicicleta-2&orientation=squarish',
    solicitante: 'Carlos Ramírez',
    solicitanteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%20friendly%20warm%20expression%20casual%20polo%20shirt%20natural%20daylight%20clean%20background%20soft%20lighting&width=80&height=80&seq=req-carlos-r-2&orientation=squarish',
    solicitanteCiudad: 'San José',
    mensaje: 'Para el equipo de fútbol del barrio. ¡Campeones del torneo!',
    dedicatoria: 'A Los Leones del Sur, los mejores del barrio.',
    estado: 'pendiente',
    fechaSolicitud: '2026-06-21T09:30:00',
    compartidos: 7,
    participantes: 3,
    score: 20,
  },
];

export const scoreAcciones: ScoreAccion[] = [
  { id: 'solicitar', accion: 'Solicitar Canción', icono: 'ri-music-line', color: 'from-rose-500 to-rose-600', puntos: 10, descripcion: 'Sumás 10 puntos cada vez que pedís una canción con dedicatoria.' },
  { id: 'compartir', accion: 'Compartir Solicitud', icono: 'ri-share-forward-line', color: 'from-amber-500 to-amber-600', puntos: 5, descripcion: 'Sumás 5 puntos por cada persona que comparte tu solicitud.' },
  { id: 'participar', accion: 'Participar en Cadena', icono: 'ri-user-voice-line', color: 'from-emerald-500 to-emerald-600', puntos: 15, descripcion: 'Sumás 15 puntos cuando tu canción pedida genera una cadena de comentarios en Cabina.' },
];

export const reglasCanciones: ReglaCanciones[] = [
  {
    id: 1,
    titulo: 'Todo dentro de Cabina',
    descripcion: 'Solicitar canciones, ver las más pedidas, seguir el estado de tu solicitud y participar en la conversación — todo sucede en la Cabina. No hay formularios externos ni páginas separadas. La Cabina es el único canal.',
    icono: 'ri-broadcast-line',
    color: 'from-rose-500 to-rose-600',
  },
  {
    id: 2,
    titulo: 'Estados claros para el oyente',
    descripcion: 'Toda canción solicitada pasa por un flujo visible: Pendiente → Aceptada → Al Aire. Si es rechazada, el oyente recibe el motivo. Nada queda en el limbo.',
    icono: 'ri-check-double-line',
    color: 'from-emerald-500 to-emerald-600',
  },
  {
    id: 3,
    titulo: 'Score por participar',
    descripcion: 'Solicitar canciones suma puntos. Compartir solicitudes suma puntos. Participar en cadenas de canciones suma puntos. El score premia la interacción genuina, no solo pedir por pedir.',
    icono: 'ri-line-chart-line',
    color: 'from-amber-500 to-amber-600',
  },
  {
    id: 4,
    titulo: 'Límites para mantener la calidad',
    descripcion: 'Máximo 3 solicitudes de la misma canción por día. Máximo 1 canción pendiente por oyente. Si abusás del sistema, tu solicitud es rechazada automáticamente. Así evitamos saturación.',
    icono: 'ri-scales-line',
    color: 'from-violet-500 to-violet-600',
  },
];

export const globalStats = {
  cancionesSolicitadasHoy: 156,
  cancionesAlAireHoy: 42,
  cancionesPendientes: 34,
  cancionesRechazadasHoy: 18,
  topCancionSolicitada: 'Vivir Mi Vida — Marc Anthony',
  totalCompartidosHoy: 312,
  scoreTotalGenerado: 1845,
};

export function getPendientes(): CancionSolicitada[] {
  return cancionesSolicitadas.filter((c) => c.estado === 'pendiente');
}

export function getAceptadas(): CancionSolicitada[] {
  return cancionesSolicitadas.filter((c) => c.estado === 'aceptada');
}

export function getAlAire(): CancionSolicitada[] {
  return cancionesSolicitadas.filter((c) => c.estado === 'al_aire');
}

export function getRechazadas(): CancionSolicitada[] {
  return cancionesSolicitadas.filter((c) => c.estado === 'rechazada');
}

export function getMasPedidas(): CancionSolicitada[] {
  return [...cancionesSolicitadas].sort((a, b) => b.score - a.score);
}

export function getUltimasPedidas(): CancionSolicitada[] {
  return [...cancionesSolicitadas].sort((a, b) => new Date(b.fechaSolicitud).getTime() - new Date(a.fechaSolicitud).getTime());
}

export const estadoLabels: Record<EstadoCancion, { label: string; bg: string; text: string; dot: string; icono: string }> = {
  pendiente: { label: 'Pendiente', bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500', icono: 'ri-time-line' },
  aceptada: { label: 'Aceptada', bg: 'bg-primary-100', text: 'text-primary-700', dot: 'bg-primary-500', icono: 'ri-check-line' },
  rechazada: { label: 'Rechazada', bg: 'bg-rose-100', text: 'text-rose-700', dot: 'bg-rose-500', icono: 'ri-close-circle-fill' },
  al_aire: { label: 'Al Aire', bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-500', icono: 'ri-broadcast-fill' },
};